import Component from './Component';
import { componentDefaults } from './defaults';
const componentIdentifiers = [];
export const registerComponent = (component, test, name) => {
    componentIdentifiers.push({ component, componentTest: test, name });
};
export const createComponent = (element) => {
    const identifier = componentIdentifiers.find(identifier => identifier.componentTest(element));
    if (identifier) {
        return new identifier.component(element, identifier.name);
    }
    return false;
};
export const isComponent = (element, componentType) => {
    const component = createComponent(element);
    if (component) {
        return component instanceof Component;
    }
    return false;
};
export const isSameComponent = (element, secondElement) => {
    const component = createComponent(element);
    const component2 = createComponent(secondElement);
    return component.constructor === component2.constructor;
};
/**
 * Register the default modules
 */
export const initComponents = () => {
    componentDefaults.forEach(item => {
        registerComponent(item.component, item.test, item.name);
    });
};
